var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3.74281C19.26 2.7524 17.64 2.7524 16.66 3.74281L8.82 11.5861C8.74 11.6661 8.68 11.7662 8.64 11.8762L7.36 15.7178C7.27 15.9879 7.34 16.288 7.54 16.4881C7.68 16.6282 7.87 16.7082 8.07 16.7082C8.15 16.7082 8.23 16.6982 8.31 16.6682L12.13 15.3576C12.24 15.3176 12.34 15.2576 12.42 15.1776L20.26 7.33431C20.74 6.85411 21 6.21384 21 5.53356C21 4.85327 20.73 4.21301 20.25 3.73281V3.74281ZM19.19 6.27386L11.47 13.9971L9.25 14.7574L10 12.5165L17.72 4.80325C18.13 4.39308 18.79 4.40308 19.19 4.80325C19.39 5.00333 19.5 5.26344 19.5 5.54356C19.5 5.82368 19.39 6.08379 19.2 6.27386H19.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.82 11.2559C18.41 11.2559 18.07 11.5961 18.07 12.0063V18.8291C18.07 19.2093 17.76 19.5094 17.38 19.5094H5.19C4.81 19.5094 4.5 19.1992 4.5 18.8291V6.62401C4.5 6.24385 4.81 5.94373 5.19 5.94373H12C12.41 5.94373 12.75 5.60359 12.75 5.19341C12.75 4.78324 12.41 4.4431 12 4.4431H5.19C3.98 4.4431 3 5.42351 3 6.62401V18.8191C3 20.0196 3.98 21 5.19 21H17.39C18.6 21 19.58 20.0196 19.58 18.8191V11.9962C19.58 11.5861 19.24 11.2459 18.83 11.2459L18.82 11.2559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a6c13bcd.svg";
export { ForwardRef as ReactComponent };